import { createUseStyles } from 'react-jss';

import { ITheme, mediaQuery } from '../../../styles';

const useStyles = createUseStyles<string, { noTextPadding?: boolean }>(
  ({ breakpoints }: ITheme) => ({
    videoContainer: {
      width: 648,
      height: 460,

      [mediaQuery(breakpoints.desktop)]: {
        width: 482,
      },

      [mediaQuery(breakpoints.tablet)]: {
        height: 'auto',
        width: '100%',
      },
    },
    video: {
      aspectRatio: '16 / 9',
      borderRadius: 28,
      width: 'inherit',
    },
  }),
  {
    name: 'VideoMedia',
  },
);

export default useStyles;
